import { Flex, Image, Text, useColorModeValue } from "@chakra-ui/react";
import {
  BsFillCameraVideoFill,
  BsFillCameraVideoOffFill,
  BsFillMicFill,
  BsFillMicMuteFill,
} from "react-icons/bs";
import { RiCheckboxBlankCircleFill } from "react-icons/ri";
import { ControlButtons } from "./ControlButtons";
import { GiSettingsKnobs } from "react-icons/gi";
import { useState } from "react";
import recordAnimation from "../../assets/record-animation.gif";
import { ImPhoneHangUp } from "react-icons/im";
import useSmallScreen from "../useSmallScreen";

function MeetingControlSmallScreen({
  fullScreen,
  setShowChat,
  setShowFloatingParticipants,
  ...props
}) {
  const iconColor = useColorModeValue("#000", "#fff");
  const [muteMic, setMuteMic] = useState(true);
  const [showCam, setShowCam] = useState(true);
  const [startedRecording, setStartedRecording] = useState(false);
  const f = useColorModeValue("#f3f3f3", "#07182E");
  const [smallScreen] = useSmallScreen();

  return (
    <Flex flexDirection={"column"}>
      {!props?.oneToOne && (
        <Flex
          mt="7px"
          maxW="240px"
          flexWrap={"wrap"}
          gap="15px"
          alignSelf={"center"}
          bg={f}
        >
          <Text>Chats</Text>
          <Text>Share Screen</Text>
          <Text>Raise Hand</Text>

          <Text>Participants</Text>
        </Flex>
      )}
      <Flex
        width="100%"
        my="20px"
        mb={props?.oneToOne ? "unset" : smallScreen ? "60px" : "20px"}
        justify="space-between"
        align={"center"}
        px="10px"
        {...props}
      >
        <ControlButtons
          onClick={() => setMuteMic((prev) => !prev)}
          icon={muteMic ? <BsFillMicMuteFill /> : <BsFillMicFill />}
          color={muteMic ? "#fff" : "#000"}
          bg={muteMic ? "#FF4246" : "#fff"}
          p="10px 18px"
          borderRadius="10px"
        />

        <ControlButtons
          onClick={() => setShowCam((prev) => !prev)}
          icon={
            showCam ? <BsFillCameraVideoFill /> : <BsFillCameraVideoOffFill />
          }
          color={showCam ? "#000" : "#fff"}
          bg={showCam ? "#fff" : "#FF4246"}
          p="10px 18px"
          borderRadius="10px"
        />

        {startedRecording ? (
          <ControlButtons
            onClick={() => setStartedRecording((prev) => !prev)}
            icon={
              <Image
                borderRadius={"6px"}
                w="25px"
                src={recordAnimation}
                alt="record animation"
              />
            }
            color="#1492E6"
            bg="#fff"
            p="10px 18px"
            borderRadius="10px"
          />
        ) : (
          <ControlButtons
            onClick={() => setStartedRecording((prev) => !prev)}
            icon={
              <RiCheckboxBlankCircleFill
                color="#fff"
              />
            }
            color="#1492E6"
            bg="#0076FF"
            p="10px 18px"
            borderRadius="10px"
          />
        )}

        <ControlButtons
          smallCurve
          icon={<GiSettingsKnobs />}
          color={"#000"}
          bg={"#fff"}
          p="10px 18px"
          borderRadius="10px"
        />
        <ControlButtons
          smallCurve
          icon={<ImPhoneHangUp />}
          color={iconColor}
          bg={"#FF4246"}
          p="10px 18px"
          borderRadius="10px"
        />
      </Flex>
    </Flex>
  );
}

export default MeetingControlSmallScreen;
